import { useAuth } from "../../../../modules/auth"
import { useTouUrlQuery, useUmsUrlQuery } from "./jguApi"

export const useGetTouUrl = () => {
    const { user } = useAuth()
    const {data} = useTouUrlQuery({email: user?.email||''})

    return { touUrl: data?.url }
}

export const useUmsUrl = () => {
    const { user } = useAuth()
    const {data} = useUmsUrlQuery({username: user?.email||''})

    return { umsUrl: data?.url }
}